var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCreateNewFolder = function SvgCreateNewFolder(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 20q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 18V6q0-.824.587-1.412A1.93 1.93 0 0 1 4 4h5.175a1.98 1.98 0 0 1 1.4.575L12 6h8q.824 0 1.413.588Q22 7.175 22 8v10q0 .824-.587 1.413A1.93 1.93 0 0 1 20 20zm0-2h16V8h-8.825l-2-2H4zm10-4v1q0 .424.287.713.288.287.713.287.424 0 .713-.287A.97.97 0 0 0 16 15v-1h1q.424 0 .712-.287A.97.97 0 0 0 18 13a.97.97 0 0 0-.288-.713A.97.97 0 0 0 17 12h-1v-1a.97.97 0 0 0-.287-.713A.97.97 0 0 0 15 10a.97.97 0 0 0-.713.287A.97.97 0 0 0 14 11v1h-1a.97.97 0 0 0-.713.287A.97.97 0 0 0 12 13q0 .424.287.713.288.287.713.287z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCreateNewFolder);
export { ForwardRef as ReactComponent };